<!-- 单条商品选择规格值 -->
<template>
  <div>
    <eDrawer
      :drawerVisible="attrInTableDrawerVisible"
      @handleDrawerSubmit="handleDrawerSubmit"
      @handleDrawerCancel="handleDrawerCancel"
    >
      <div class="drawer-wrap">
        <div class="table-head-wrap">
          <div class="table-head-1">规格名称</div>
          <div class="table-head-2">
            值
            <el-input
              style="width: 180px"
              placeholder="请输入查询数据,按回车搜索"
              suffix-icon="el-icon-search"
              v-model="searchAttrValue"
              @keyup.enter.native="handleSearchAttrValue"
            >
            </el-input>
          </div>
          <div class="table-head-1">计量单位值</div>
        </div>
        <div class="table-body-wrap">
          <div class="table-body-left">
            <div class="table-body-1 attribute-name">
              {{ selStandardObj.attributeName }}
            </div>
          </div>
          <div class="table-body-center">
            <div class="table-body-2">
              <el-radio-group v-model="standardVal" @change="standardHandle">
                <el-radio
                  :label="item.attributeValue"
                  v-for="item in selStandardObj.attributeValueListPage.records"
                  :key="item.attributeValueId"
                >
                  {{ item.attributeValue }}
                  <i
                    v-if="item.attributeValueId == ''"
                    class="el-icon-close"
                    @click="deleteFormatVal(item.attributeValue)"
                  ></i>
                </el-radio>
              </el-radio-group>
              <div v-if="selStandardObj.customFlag == 1">
                <el-input
                  class="attr-input"
                  style="width: 100px"
                  v-model="formatVal"
                ></el-input>
                <!-- <div @click="addFormatVal" class="add-attr-btn">
                  <i class="el-icon-plus"></i>
                </div> -->
                <div class="add-attr-btn-wrap">
                  <eui-btn type="text" @click="addFormatVal()">添加</eui-btn>
                  <eui-btn
                    type="text"
                    @click="showMoreAttr()"
                    v-if="
                      selStandardObj.attributeValueListPage.size <
                      selStandardObj.attributeValueListPage.total
                    "
                    >加载更多</eui-btn
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="table-body-right">
            <div class="table-body-1">
              <el-radio-group v-model="unitVal" @change="unitHandle">
                <el-radio
                  :label="item.unitId"
                  v-for="item in selStandardObj.unitList"
                  :key="item.unitId"
                >
                  {{ item.unitName }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="select-title">已选择</div>
        <div class="select-attr-wrap">
          <div class="table-row">
            <div class="table-col-1">
              <div class="value-title">{{ currentStandardName }}-值</div>
              <div class="value-wrap">
                <div
                  class="value-item"
                  v-for="(
                    attrItem, index
                  ) in showSelectAttrAndUnitList.selectedAttributeValueList"
                  :key="attrItem.attributeId"
                >
                  {{ attrItem.attributeValue }}
                  <span @click="handleDelectAttrAndUnit('value')">
                    <eui-icon icon="eicon-close" font-size="12px"></eui-icon>
                  </span>
                </div>
              </div>
            </div>
            <div class="table-col-2">
              <div class="value-title">{{ currentStandardName }}-计量单位</div>
              <div class="value-wrap">
                <div
                  class="value-item"
                  v-for="subunititem in showSelectAttrAndUnitList.selectedUnitList"
                >
                  {{ subunititem.unitName }}
                  <span @click="handleDelectAttrAndUnit('unit')">
                    <eui-icon icon="eicon-close" font-size="12px"></eui-icon>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </eDrawer>
  </div>
</template>

<script>
import api from '../../../api/product/index.js';
import eDrawer from './batchAddProduct.vue';
import util from '../../../utils/utils';

export default {
  props: {
    attrInTableDrawerVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      attrLoading: false,
      searchAttrValue: null,
      standardVal: '',
      unitVal: '',
      unitRadioObj: {}, //规格单位值
      standardRadioObj: {}, //规格值
      unitListTable: [], //单位列表
      standardList: [], //规格列表
      selStandardObj: {
        attributeValueListPage: { records: [] },
        unitList: [],
      }, // 当前编辑的规格的对象数据
      tableIndex: 0, //商品列表的当前行
      tableId: null, //商品列表当前行id
      currentStandardName: '',
      pageSize: 30,
      showSelectAttrAndUnitList: {
        selectedAttributeValueList: [],
        selectedUnitList: [],
      },
      formatVal: '',
      drawerVisible: false,
      attributeName: '',
      currentAttributeId: '',
    };
  },

  components: {
    eDrawer,
  },

  computed: {},

  created() {},
  methods: {
    async initData(val) {
      console.log(val);
      this.pageSize = 30;
      this.searchAttrValue = null;
      this.standardVal = '';
      this.unitVal = '';
      this.unitRadioObj = {};
      this.tableIndex = val.index;
      this.tableId = val.id;
      this.currentStandardName = val.standardName; //当前规格名字
      this.currentAttributeId = val.val;
      (this.showSelectAttrAndUnitList = {
        selectedAttributeValueList: [],
        selectedUnitList: [],
      }),
        await this.getAttrByPage(this.pageSize, val.val);
      this.drawerVisible = !this.drawerVisible;
      // if (res.code == 200) {
      // let standardList = res;
      // for (let i = 0; i < standardList.length; i++) {
      //   if (standardList[i].attributeId == val.val) {
      //     this.selStandardObj = standardList[i];
      //     break;
      //   }
      // }
      // console.log(this.selStandardObj);
      // if (this.selStandardObj.attributeName == undefined) {
      //   this.$message.warning(
      //     '您发布的商品中有停用的属性，请刷新界面，重新发布'
      //   );
      // }
      // localStorage.setItem(
      //   'selStandardObj',
      //   JSON.stringify(this.selStandardObj)
      // );
      // this.attrLoading = false;
      // } else {
      // this.$message.error(res.message);
      // return;
      // }
    },
    //  获取根据分页获取规格
    async getAttrByPage(pageSize, attributeId, attributeValue) {
      let res = await api.getPropertyByCategoryByPage({
        categoryId: this.$store.state.productList.categoryId,
        attributeType: 2,
        pageNum: 0,
        pageSize: pageSize,
        attributeId: attributeId,
        attributeValue: attributeValue ? attributeValue : '',
      });
      if (res.code === '200') {
        let standardList = res.data;
        for (let i = 0; i < standardList.length; i++) {
          if (standardList[i].attributeId == attributeId) {
            this.selStandardObj = standardList[i];
            break;
          }
        }
        console.log(this.selStandardObj);
        if (this.selStandardObj.attributeName == undefined) {
          this.$message.warning(
            '您发布的商品中有停用的属性，请刷新界面，重新发布'
          );
        }
        localStorage.setItem(
          'selStandardObj',
          JSON.stringify(this.selStandardObj)
        );
        this.attrLoading = false;
      }
    },
    // 确定选择规格计量单位
    handleDrawerSubmit() {
      console.log(this.unitRadioObj);
      console.log(this.standardRadioObj);
      if (util.isEmptyObject(this.standardRadioObj)) {
        this.$message.warning('请先选择取值与计量单位');
        return;
      }
      if (
        this.selStandardObj.unitList.length > 0 &&
        util.isEmptyObject(this.unitRadioObj)
      ) {
        this.$message.warning('请先选择取值与计量单位');
        return;
      }
      (this.showSelectAttrAndUnitList = {
        selectedAttributeValueList: [],
        selectedUnitList: [],
      }),
        this.$emit('handleDrawerSubmitInTable', {
          selStandardObj: this.selStandardObj,
          unitRadioObj: this.unitRadioObj,
          standardRadioObj: this.standardRadioObj,
        });
    },
    // 清空选择
    handleDrawerClear() {
      this.showSelectAttrAndUnitList.selectedAttributeValueList = [];
      this.standardVal = '';
      this.standardRadioObj = {};
      this.showSelectAttrAndUnitList.selectedUnitList = [];
      this.unitVal = '';
      this.unitRadioObj = {};
    },
    handleDrawerCancel() {
      this.drawerVisible = false;
      this.$emit('handleDrawerCancel');
    },
    handleDelectAttrAndUnit(type) {
      if (type === 'value') {
        this.showSelectAttrAndUnitList.selectedAttributeValueList = [];
        this.standardVal = '';
        this.standardRadioObj = {};
      } else {
        this.showSelectAttrAndUnitList.selectedUnitList = [];
        this.unitVal = '';
        this.unitRadioObj = {};
      }
    },
    async showMoreAttr() {
      this.pageSize += 30;
      await this.getAttrByPage(
        this.pageSize,
        this.currentAttributeId,
        this.searchAttrValue
      );
      console.log(this.showSelectAttrAndUnitList);
      if (
        this.showSelectAttrAndUnitList.selectedAttributeValueList.length > 0 &&
        this.showSelectAttrAndUnitList.selectedAttributeValueList[0]
          .attributeValueId === ''
      ) {
        this.selStandardObj.attributeValueListPage.records.push({
          attributeValueId:
            this.showSelectAttrAndUnitList.selectedAttributeValueList[0]
              .attributeValueId,
          attributeValue:
            this.showSelectAttrAndUnitList.selectedAttributeValueList[0]
              .attributeValue,
          attributeValueCode: '',
        });
      }
    },
    addFormatVal() {
      console.log(util.deleteSpace(this.formatVal));
      if (util.deleteSpace(this.formatVal) == '') {
        this.$message.warning('规格值不能为空！');
        return;
      }
      if (
        util.getArgumentIndexInAttr(
          this.selStandardObj.attributeValueListPage.records,
          'attributeValue',
          this.formatVal
        ) == -1
      ) {
        if (util.deleteSpace(this.formatVal).length > 20) {
          this.$message.warning('规格值不能超过20个字');
          return;
        } else {
          this.selStandardObj.attributeValueListPage.records.push({
            attributeValue: this.formatVal,
            attributeValueId: '',
            //  checked: false
          });
          //副本操作
          let copySelStandardObj = localStorage.getItem('selStandardObj');
          copySelStandardObj = JSON.parse(copySelStandardObj);
          copySelStandardObj.attributeValueListPage.records.push({
            attributeValue: this.formatVal,
            attributeValueId: '',
            //  checked: false
          });
          localStorage.setItem(
            'selStandardObj',
            JSON.stringify(copySelStandardObj)
          );
        }
      } else {
        this.$message.warning('规格值不能重复');
      }

      this.formatVal = '';
    },
    //规格弹框的规格选择
    standardHandle(val) {
      console.log(this.standardVal);
      let obj = util.getSelectLabel(
        this.selStandardObj.attributeValueListPage.records,
        val,
        'attributeValue'
      );
      this.showSelectAttrAndUnitList.selectedAttributeValueList = [];
      console.log(obj);
      this.standardRadioObj = obj;
      this.standardRadioObj.beforeSymbol = this.selStandardObj.beforeSymbol;
      this.standardRadioObj.behindSymbol = this.selStandardObj.behindSymbol;
      this.standardRadioObj.connectSymbol = this.selStandardObj.connectSymbol;
      // this.ruleForm.taxName = obj.taxRateValue;
      this.showSelectAttrAndUnitList.selectedAttributeValueList.push(obj);
      console.log(this.standardRadioObj);
    },
    // 选择计量单位
    unitHandle(val) {
      let obj = util.getSelectLabel(
        this.selStandardObj.unitList,
        val,
        'unitId'
      );
      console.log(obj);
      this.unitRadioObj = obj;
      this.showSelectAttrAndUnitList.selectedUnitList = [];
      this.showSelectAttrAndUnitList.selectedUnitList.push(obj);
      console.log(this.showSelectAttrAndUnitList);
    },
    async handleSearchAttrValue() {
      await this.getAttrByPage(
        this.pageSize,
        this.currentAttributeId,
        this.searchAttrValue
      );
    },
    deleteFormatVal(val) {
      let index = util.getArgumentIndexInAttr(
        this.selStandardObj.attributeValueListPage.records,
        'attributeValue',
        val
      );
      if (index !== -1) {
        this.selStandardObj.attributeValueListPage.records.splice(index, 1);
      }

      //副本操作
      let copySelStandardObj = localStorage.getItem('selStandardObj');
      copySelStandardObj = JSON.parse(copySelStandardObj);
      let copyIndex = util.getArgumentIndexInAttr(
        copySelStandardObj.attributeValueListPage.records,
        'attributeValue',
        val
      );
      copySelStandardObj.attributeValueListPage.records.splice(copyIndex, 1);
      localStorage.setItem(
        'selStandardObj',
        JSON.stringify(copySelStandardObj)
      );
      // 删除已选项
      let selectIndex = util.getArgumentIndexInAttr(
        this.showSelectAttrAndUnitList.selectedAttributeValueList,
        'attributeValue',
        val
      );
      if (selectIndex !== -1) {
        this.showSelectAttrAndUnitList.selectedAttributeValueList.splice(
          selectIndex,
          1
        );
      }
      if (index !== -1 && selectIndex !== -1) {
        this.standardRadioObj = {};
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.table-head-wrap {
  display: flex;
  flex-flow: row;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  background: #f5f5f5;

  .table-head-1 {
    width: 140px;
    border: 1px solid #dcdcdc;
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 10px;
  }
  .table-head-2 {
    width: 522px;
    height: 40px;
    display: flex;
    align-items: center;
    border-top: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 10px;
    padding-right: 10px;
  }
}
.table-body-wrap {
  display: flex;
  flex-flow: row;
  border-left: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
  border-right: 1px solid #dcdcdc;
  .table-body-1 {
    // width: 140px;
    // border-left: 1px solid #dcdcdc;
    &.attribute-name {
      height: 22px;
      cursor: pointer;
      font-size: 14px;
      color: #333;
      display: flex;
      align-items: center;
      padding: 4px;
      margin-bottom: 8px;
    }
    &.isActive {
      background: #e8f3ff;
      padding: 4px;
    }
  }
  .table-body-2 {
    width: 500px;
  }
  .table-body-left,
  .table-body-center,
  .table-body-right {
    height: 400px;
    padding: 10px;
  }
  .table-body-left {
    width: 140px;
  }
  .table-body-center {
    border-left: 1px solid #dcdcdc;
    border-right: 1px solid #dcdcdc;
    overflow: auto;
  }
  .add-attr-btn-wrap {
    display: inline-block;
    text-align: center;
  }
}
.select-title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 10px;
}
.select-attr-wrap {
  overflow: auto;
  height: 300px;
  .table-row {
    display: flex;
    flex-flow: row;
    min-height: 62px;
    &:nth-child(odd) {
      background: #f8f8f8;
    }
    .table-col-1 {
      width: 80%;
      padding: 10px;
      border-top: 1px solid #dcdcdc;
      border-left: 1px solid #dcdcdc;
      border-bottom: 1px solid #dcdcdc;
    }
    .table-col-2 {
      width: 20%;
      padding: 10px;
      border: 1px solid #dcdcdc;
    }
    .value-title {
      font-size: 12px;
      color: #333;
      line-height: 1;
    }
    .value-wrap {
      display: flex;
      flex-flow: wrap;
      margin-top: 10px;
      .value-item {
        border: 1px solid #d9d9d9;
        font-size: 12px;
        color: #666;
        padding: 4px 8px;
        background: #fff;
        margin-right: 10px;
        line-height: 1;
        flex-shrink: 0;
        margin-bottom: 10px;
      }
    }
  }
}

.attr-input ::v-deep .el-input__inner {
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 0 !important;
  line-height: 30px;
  height: 30px;
}
.attr-txt {
  height: 40px;
  border-left: 1px solid #ededed;
  line-height: 40px;
  padding-left: 10px;
}
::v-deep .el-checkbox__label {
  white-space: normal;
  word-break: break-all;
}
::v-deep .el-radio {
  white-space: normal;
  word-break: break-all;
}
.drawer-wrap {
  height: calc(100% - 30%);
  overflow: auto;
}
</style>
